// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconHardwareMicroscopeSettings_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M11 0H5V14L6 16H10L11 14V0ZM14.8796 23.2548C14.2773 23.4903 13.6489 23.6737 13 23.7997V21.5654C13.31 21.4893 13.6166 21.3959 13.9183 21.2853 16.2709 20.4211 18.1482 18.5727 19.0512 16.2391 19.4005 15.334 19.5935 14.3824 19.63 13.426 19.6342 13.3148 19.6363 13.203 19.6363 13.0908 19.6363 12.9941 19.6347 12.8978 19.6316 12.802 19.5657 10.8009 18.8153 8.81825 17.3803 7.23514 17.2834 7.12821 17.1834 7.02311 17.0802 6.91996 16.9662 6.80592 16.8498 6.69571 16.7312 6.5893 16.0713 5.99801 15.321 5.5057 14.5034 5.13572 14.016 4.91563 13.5126 4.74261 13 4.61665V2.38199C13.7699 2.53144 14.5108 2.76184 15.2137 3.06398 15.8993 3.35808 16.561 3.72572 17.1866 4.16691L19.3944 3.06303 20.9371 4.6058 19.8332 6.81357C20.3058 7.48374 20.694 8.19523 20.9979 8.93329 21.2973 9.65923 21.5208 10.4246 21.6582 11.2194L23.9999 11.9999V14.1818L21.6582 14.9623C21.5295 15.7065 21.3255 16.4249 21.0541 17.1092 20.7425 17.8972 20.3356 18.6561 19.8333 19.3684L20.9371 21.5762 19.3944 23.119 17.1866 22.0151C16.4599 22.5276 15.6846 22.9408 14.8796 23.2548ZM11 18H0V20H11V18Z" class="svg-bg"/>
</svg>
`;
/**
 * IconHardwareMicroscopeSettings is a generated icon component.
 */
let IconHardwareMicroscopeSettings = IconHardwareMicroscopeSettings_1 = class IconHardwareMicroscopeSettings extends IconBaseElement {
    render() {
        return html `${IconHardwareMicroscopeSettings_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconHardwareMicroscopeSettings.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconHardwareMicroscopeSettings = IconHardwareMicroscopeSettings_1 = __decorate([
    customElement('zui-icon-hardware-microscope-settings')
], IconHardwareMicroscopeSettings);
export { IconHardwareMicroscopeSettings };
